import WidgetModule from "@eisinc/Overrides/Widgets/SignIn/SignInExistingAccount";

export * from "@eisinc/Overrides/Widgets/SignIn/SignInExistingAccount";

export default WidgetModule;
